<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.dataFiled.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/dataField">
              <span>{{$t('tlt.dataFiled.list')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/dataField/edit">
              <span>{{$t('tlt.dataFiled.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('dataField')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <!-- <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button> -->
          <button class="btn btn-primary" type="button" v-on:click="MMFSave('dataField')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>

    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.name')}}:
                </label>
                <select
                  v-validate="'required'"
                  name="name"
                  :class="{'form-control': true, 'is-invalid': errors.has('name') }"
                  v-model="name"
                >
                  <option :key="index" v-for="(model,index) in models">{{model}}</option>
                </select>
              </div>


              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.attribute')}}:
                </label>
                <select
                  v-validate="'required'"
                  name="attribute"
                  :class="{'form-control': true, 'is-invalid': errors.has('attribute') }"
                  v-model="attribute"
                >
                  <option :key="index" v-for="(modelField,index) in modelFields">{{modelField}}</option>
                </select>
              </div>


              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.upperLimit')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="upperLimit"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('upperLimit') }"
                  v-model="upperLimit"
                  type="text"
                />
                <span
                  v-show="errors.has('upperLimit')"
                  class="lbl-obg"
                >{{ errors.first('upperLimit') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.lowerLimit')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="lowerLimit"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('lowerLimit') }"
                  v-model="lowerLimit"
                  type="text"
                />
                <span
                  v-show="errors.has('lowerLimit')"
                  class="lbl-obg"
                >{{ errors.first('lowerLimit') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.upperColor')}}:
                </label>
                <div style="position:relative;left:40px">
                          <el-color-picker  v-model="upperColor"></el-color-picker>
                </div>
                <span
                  v-show="errors.has('upperColor')"
                  class="lbl-obg"
                >{{ errors.first('upperColor') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.lowerColor')}}:
                </label>
                <div style="position:relative;left:40px">
                          <el-color-picker  v-model="lowerColor"></el-color-picker>
                </div>
                <span
                  v-show="errors.has('lowerColor')"
                  class="lbl-obg"
                >{{ errors.first('lowerColor') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.description')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="description"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('description') }"
                  v-model="description"
                  type="text"
                />
                <span
                  v-show="errors.has('description')"
                  class="lbl-obg"
                >{{ errors.first('description') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { fields } from "@/model/adm/DataField";
import allModel from "@/model/index";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "dataField/getField",
  mutationType: "dataField/updateField"
});

export default {
  name: "dataFieldEdit",
  data() {
    return {
      models: "",
      modelFields:""
    };
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.dataField.rows,

      entity: state => state.dataField.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"])
  },
  created() {
    this.models = Object.keys(allModel);
    this.modelFields=allModel[this.name].fields.map(i => i.replace('entity.',''));
    
  },
  watch:{
    name:{
      handler(val){
     this.modelFields=allModel[val].fields.map(i => i.replace('entity.',''));
      }
    }
  }
};
</script>
